import React from 'react';
import {connect} from 'react-redux';
import {ThemeProvider} from 'react-jss';

import App from '-/components/connected/App';
import UIService from '-/services/UIService';
import {fetchInfo} from '-/actions/actions';
import {getTheme} from '-/styles/utils';

class Theme extends React.Component {
    render() {
        return (
            <ThemeProvider theme={getTheme()}>
                <App />
            </ThemeProvider>
        );
    }

    componentDidMount() {
        const {fetchInfo} = this.props;
        UIService.setLoading(true);

        fetchInfo().then(() => {
            UIService.setLoading(false);
        }).catch(() => {
            UIService.setLoading(false);
        });
    }
}

const mapStateToProps = (state) => {
    const {initialized, error, loading} = state.ui;

    return {
        initialized,
        error,
        loading
    };
};

export default connect(mapStateToProps, {fetchInfo})(Theme);
